class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 600).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);


// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getCartCountCart(){
  var cartContents = fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json()).then(data => {
    document.querySelector("#cart_item_desktop").textContent = data.item_count
    document.querySelector("#cart_item_mobile").textContent = data.item_count
  });
}

function whatsappShare(){
  var productName = "{{ product.title }}";
  var productURL = "{{ shop.url }}{{ product.url }}";
  var whatsappMessage = encodeURIComponent("Check out this product: " + productName + "\n" + productURL);
  var whatsappURL = "https://wa.me/?text=" + whatsappMessage;
  window.open(whatsappURL, '_blank');
}
var productInfoElement = document.querySelector('.product--information');
if(productInfoElement){
  let slider = document.querySelector('.product--information').dataset.slider;
}


function getVariantFromOptions() {
  let variantArr = [];
  document.querySelectorAll(".variant-dropdown select").forEach(function(el, i) {
    let variant = { value: el.value, index: el.getAttribute('data-index') };
    variantArr.push(variant);
  });
  return variantArr;
}

function getVariantFromSwatches() {
  let variantArr = [];
  document.querySelectorAll(".variant-swatches input[type=radio]").forEach(function(el, i) {
    if (el.checked) {
      variantArr.push({ value: el.value, index: el.getAttribute('data-index') });
    }
  });
  return variantArr;
}

function updateURL(variant) {
  if (!history.replaceState || !variant) {
    return;
  }
  var newUrl =
    window.location.protocol +
    '//' +
    window.location.host +
    window.location.pathname +
    '?variant=' +
    variant.id;

  window.history.replaceState({ path: newUrl }, '', newUrl);
}

function updateFormID(currentVariant) {
  const form_input = document.querySelector("#product-form").querySelector('input[name="id"]');
  form_input.value = currentVariant.id;
}


function updatePrice(currentVariant, url,section) {
  fetch(`${url}?variant=${currentVariant.id}&section_id=${section}`)
  .then(response => response.text())
  .then((responseText) => {
    const id = `price-${section}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const oldPrice = document.getElementById(id);
    const newPrice = html.getElementById(id);
    if (oldPrice && newPrice) {
      oldPrice.innerHTML = newPrice.innerHTML;
    }
  })
  .catch(error => {
    console.error('Error fetching variant price:', error);
  });
}

// function updatePriceOnPage(newPrice, comparePrice) {
//   const priceContainer = document.querySelector('#price-container');
//   if (priceContainer) {
//     // Find the price and compare price elements
//     const originalPriceElement = priceContainer.querySelector('h3');
//     const comparePriceElement = priceContainer.querySelector('h5');
    
//     // Update the original price
//     if (originalPriceElement) {
//       originalPriceElement.textContent = newPrice;
//     }
    
//     // Update the compare-at price
//     if (comparePriceElement) {
//       if (comparePrice) {
//         comparePriceElement.textContent = comparePrice;
//         comparePriceElement.style.display = 'inline';
//       } else {
//         comparePriceElement.style.display = 'none';
//       }
//     }
//   }
// }

function updateAddToCart(currentVariant) {
  let adc = document.querySelector('#adcText');
  let adcText = document.querySelector('#addToCartButton').dataset.adc;
  let soldText = document.querySelector('#addToCartButton').dataset.sold;
  if (currentVariant.available == false) {
    adc.innerHTML = soldText;
    adc.setAttribute("disabled", "disabled");
  } else {
    adc.innerHTML = adcText;
    adc.removeAttribute('disabled');
  }
}
function getSku(currentVariant) {
  var skuCode = currentVariant.sku;
  if (skuCode != "") {
    document.querySelector('sku_number').textContent(skuCode);
  }
}
if(productInfoElement){
  var sliderType = document.querySelector('.product--information').dataset.slider;
  if(sliderType == 'slider') {
          var isThumbnailsEnabled = window.themeSettings.isThumbnailsEnabled;
          if(isThumbnailsEnabled){
            var thumbnails = new Swiper("#slider__thumbs", {
              loop: true,
              spaceBetween: 10,
              slidesPerView: 4,
              freeMode: true,
              watchSlidesProgress: true,
              //direction: 'vertical',
              navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
            });
          

            var galleryTop = new Swiper("#main-slider", {
              // loop: true,
                spaceBetween: 0,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                thumbs: {
                  swiper: thumbnails,
                },
            });
            function goToSlide(index){
              galleryTop.slideTo(index)
            }
        }else{
            var galleryTop = new Swiper("#main-slider", {
                // loop: true,
                  spaceBetween: 0,
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                  }
              });
            function goToSlide(index){
              galleryTop.slideTo(index)
            }
        }  
  }
}

  document.querySelectorAll('.variant-dropdown select').forEach(function(selectElement) {
    selectElement.addEventListener('change', function() {
        let productUrl = document.querySelector('.product--information').dataset.url;
        let section = document.querySelector('.product--information').dataset.section;
        let slider = document.querySelector('.product--information').dataset.slider;
        let sku = document.getElementById('product_sku');
        var selectedValues = getVariantFromOptions();
        var variants = window.product.variants;
        var currentVariant = false;

        variants.forEach(function(variant) {
          var satisfied = true;
          var options = variant.options;

          selectedValues.forEach(function(option) {
            if (satisfied) {
              satisfied = option.value === variant[option.index];
            }
          });
          if (satisfied) {
            currentVariant = variant;
          }
        });
       console.log(currentVariant);
        updateURL(currentVariant);
        updateFormID(currentVariant);
        updatePrice(currentVariant, productUrl, section);
        updateAddToCart(currentVariant);
        if(slider == 'slider'){
          if(currentVariant.featured_image != null){ 
            const divId = currentVariant.featured_image.id;
            const index = document.getElementById(divId).dataset.index;
            console.log(index);
            goToSlide(index)
          }
        }

        if(sku){
          getSku(currentVariant);
        }
    });
  });

  document.querySelectorAll('.product_variant').forEach(function(radioInput) {
    radioInput.addEventListener('change', function() {
      let productUrl = document.querySelector('.product--information').dataset.url;
        let section = document.querySelector('.product--information').dataset.section;
        let slider = document.querySelector('.product--information').dataset.slider;
        let sku = document.getElementById('product_sku');
        var selectedValues = getVariantFromSwatches();
        var variants = window.product.variants;
        var currentVariant = false;
        variants.forEach(function(variant) {
            var satisfied = true;
            var options = variant.options;
            
            selectedValues.forEach(function(option) {
                if (satisfied) {
                    satisfied = option.value === variant[option.index];
                }
            });

            if (satisfied) {
              currentVariant = variant;
            }
        });
        console.log(currentVariant);
        updateURL(currentVariant);
        updateFormID(currentVariant);
        updatePrice(currentVariant, productUrl,section);
        updateAddToCart(currentVariant);
        if(slider == 'slider'){
          if(currentVariant.featured_image != null){ 
            const divId = currentVariant.featured_image.id;
            const index = document.getElementById(divId).dataset.index;
            goToSlide(index)
          }
        }
        if(sku){
          getSku(currentVariant);
        }
    });
});

// let allLabels = document.querySelectorAll('.optionContainer');
// if(allLabels){
//   allLabels.forEach(item => {
//     item.addEventListener('click', () => {
//         // Remove active class from all labels
//         document.querySelector('.optionContainer.activeOption')?.classList.remove('activeOption');
//         // Add active class to the clicked one
//         item.classList.add('activeOption');
//     });
// });
// }


let adc = document.getElementById('addToCartButton');
if(adc){
adc.addEventListener('click', function() {
  let variant = document.querySelector("#product-form").querySelector('input[name="id"]').value;
  let qty = document.getElementById('Quantity').value;
  let loader = document.getElementById('loader');
  loader.classList.remove('hidden');
  loader.classList.add('flex');
  let formData = {
    'items': [
      {
        'id': variant,
        'quantity': qty
      }
    ]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    /*getAjaxCart();*/
    window.dispatchEvent(new Event("cart-updated"));
      loader.classList.remove('flex');
      loader.classList.add('hidden');
      window.dispatchEvent(new Event("toggle-cart"));
      getCartCountCart();
  }).catch((error) => {
    console.error('Error:', error);
  });
})
}
/**Product loop add to cart button */

function add_to_cart(productID){
  let adcText = document.getElementById(productID);
  let loader = document.getElementById('loader-'+productID);
  adcText.classList.remove('flex');
  adcText.classList.add('hidden');
  loader.classList.remove('hidden');
  loader.classList.add('flex');
  let formData = {
    'items': [
      {
        'id': productID,
        'quantity': 1
      }
    ]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
      adcText.classList.remove('hidden');
      adcText.classList.add('flex');
      loader.classList.remove('flex');
      loader.classList.add('hidden');
      new Noty({
        type: 'success',
        layout: 'topRight',
        timeout:1000,
        progressBar:true,
        text: 'Product added to cart',
      }).show();
      window.dispatchEvent(new Event("cart-updated"));
      getCartCountCart();
  }).catch((error) => {
    console.log(error);
      adcText.classList.remove('hidden');
      adcText.classList.add('flex');
      loader.classList.remove('flex');
      loader.classList.add('hidden');
      new Noty({
        type: 'error',
        layout: 'topRight',
        timeout:1000,
        text: 'Problem occurred! Try again later.',
      }).show();
  });
}
function goToCheckout(productID){
  let formData = {
        'items': [
        {
          'id': productID,
          'quantity': 1
        }
      ]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => {
      window.dispatchEvent(new Event("cart-updated"));
        getCartCountCart();
      window.location.href = '/checkout';
    }).catch((error) => {
      console.log('Error')
    });
}

